import ActionBtn from "components/buttons/ActionBtn";
import { RefreshButton } from "components/buttons/RefreshButton";
import { t } from "i18next";
import React from "react";

type Props = {
  createModal?: () => void;
  isCreateAllowed?: boolean;
  refresh?: () => void;
  isRefreshRequested?: boolean;
};

export const KeyPresetsHeader: React.FC<Props> = ({
  createModal = () => { },
  isCreateAllowed,
  refresh = () => { },
  isRefreshRequested
}) => {
  return (
    <div className="page-list-header">
      <div className="page-list-header--box">
        {isCreateAllowed && (
          <ActionBtn
            txt={t("addNotification")}
            handleClick={() => {
              if (createModal) {
                createModal();
              }
            }}
          />
        )}
      </div>
      <div className="page-list-header--box page-list-header--box--right">
        <RefreshButton
          position="right"
          disabled={isRefreshRequested}
          isLoading={isRefreshRequested}
          onClick={() => refresh()}
        />
      </div>
    </div>
  );
};
